import { TryPageTemplate } from "@/templates/try/try-page/src";

export const TryPage = () => <TryPageTemplate />;
